/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import { utils } from '@rjsf/core';
import { DatePicker } from '../../stories/DatePicker';
import { CustomWidgetProps } from '../types';

const { utcToLocal, getDisplayLabel } = utils;

const DateWidget: React.FC<React.PropsWithChildren<CustomWidgetProps>> = ({
  id,
  placeholder,
  disabled,
  label,
  readonly: readOnly,
  value,
  onChange,
  schema,
  uiSchema,
  formContext: { onHasChanged },
}: CustomWidgetProps) => {
  const _value = utcToLocal(value);

  const _onChange = (nextValue: string) => {
    // DatePicker only emits '' (explicit clear) or a valid YYYY-MM-DD string.
    onChange(nextValue || undefined);
  };

  const _onHasChanged = (newValue: string, oldValue: string) => {
    // newValue is DatePicker's plain 'YYYY-MM-DD'; oldValue is utcToLocal's
    // 'YYYY-MM-DDTHH:mm:ss.SSS' — both share this date-only prefix.
    const oldDateOnly = oldValue.slice(0, 10);
    if (newValue !== oldDateOnly) onHasChanged?.({ id, value: newValue });
  };

  const displayLabel = getDisplayLabel(schema, uiSchema);

  return (
    <>
      <DatePicker
        className="date-widget"
        label={displayLabel ? label || schema.title || '' : placeholder || ''}
        value={_value}
        disabled={disabled}
        readOnly={readOnly}
        onChange={(nextValue: string | null) => {
          const committed = nextValue || '';
          _onChange(committed);
          onHasChanged && setTimeout(() => _onHasChanged(committed, _value), 0);
        }}
        sx={{
          '&.date-widget': {
            border: '1px solid #D5D7DA',
            borderRadius: '8px',
          },
          '&.date-widget.Mui-focused': {
            '& fieldset': {
              borderWidth: 0,
            },
          },
        }}
      />
    </>
  );
};

export default DateWidget;
